import * as React from "react";
import { ScrollIntoView } from "@grandvisionhq/common";
import { Heading, Text } from "@grandvisionhq/elements";
const SuccessMessage = ({ labels }) => /* @__PURE__ */ React.createElement("section", { className: "customer-support__success", "data-t": "customer-support-success" }, /* @__PURE__ */ React.createElement(ScrollIntoView, null, /* @__PURE__ */ React.createElement(Heading, { component: "h2", variant: "medium", align: "center" }, labels.title), /* @__PURE__ */ React.createElement(Text, { variant: "body", align: "center" }, labels.content)));
export {
  SuccessMessage as default
};
//# sourceMappingURL=SuccessMessage.js.map
